import axios from 'axios';
import router from "../router";

const store = require('../store/index')
const { getBaseUrl } = require('./helper')

export default (module) => {
  return axiosState(module)
}

function axiosState(module) {
  let instance
  switch (module) {
    case 'node-api':
      instance = axios.create({
        baseURL: getBaseUrl()
      });
      break
    default:
      return false
  }

  //Add request interceptor
  instance.interceptors.request.use( (config) => {
    config.headers.Authorization = `Bearer ${store.default.state.jwt}`
    config.headers['x-app-key'] = `a11790fefd39c8a98ec4dde3b73eb405e79900fb91eace4237eb069cfcfb87f0`
    // console.log(config)
    return config;
  })
  
  // Add a response interceptor
  instance.interceptors.response.use( (response) => {
    return response;
  },  (e) => {

    if (e.response.status === 403) { // handle no or expired session
      router.push('/login').then()
    } else if (e.response.status === 401) { // handle no or expired session
      router.push(`/login?refresh=1&return_page=${window.location.pathname}`).then()
    } else {
      if (e.response.data.error && e.response.data.error.message) {
        if (process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'development') {
          console.log(e.response.data.error.message || 'Oops, something went wrong')
          console.log(e.response.data.error.errorMessage, 'errorMessage')
        }
        
        store.default.commit(
            'setResponseMsg',
            e.response.data.error.message || 'Oops, something went wrong'
        )
      }
    }
    return Promise.reject(e);
  });
  return instance
}
